/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { APIGateways } from "../../../utility/APIGateways";
import buildGetURL from "../../../utility/urlHelper";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin promptsManager/services/languageServices";

export const getLanguages = async () => {
	try {
		const url = buildGetURL(APIGateways.settingsInfoEndpoint, {
			action: "languages",
		});

		const result = await fetch(url, { headers: await getAuthHeader() });
		const resultLanguages = await result.json();
		const { languages } = resultLanguages;

		return languages.map((lang) => lang.language);
	} catch (error) {
		v2.error("Error while getting prompt languages", {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_PROMPT_LANGUAGES_API_ERROR,
		});
		return [];
	}
};

export const addLanguage = async (language) => {
	try {
		const result = await fetch(APIGateways.updateSettingEndpoint, {
			method: "POST",
			headers: await getAuthHeader(),
			body: JSON.stringify({
				action: "addlanguage",
				language,
			}),
		});

		return await result.json();
	} catch (error) {
		v2.error("Error while adding prompt language", {
			additionalData: { error: errorToObject(error), data: { language } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.ADD_PROMPT_LANGUAGE_API_ERROR,
		});

		const response = {
			status: "fail",
			result: error,
		};
		return response;
	}
};

export const deleteLanguage = async (language) => {
	try {
		const result = await fetch(APIGateways.updateSettingEndpoint, {
			method: "POST",
			headers: await getAuthHeader(),
			body: JSON.stringify({
				action: "deletelanguage",
				language,
			}),
		});

		return await result.json();
	} catch (error) {
		v2.error("Error while deleting prompt language", {
			additionalData: { error: errorToObject(error), data: { language } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.DELETE_PROMPT_LANGUAGE_API_ERROR,
		});

		const response = {
			status: "fail",
			result: error,
		};
		return response;
	}
};
